export default {"src":"/_next/static/media/digitial1.a6f18594.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};